/**
 * Aparência fora do Painel (lançador, login, Automações, Estúdio): lê e grava a mesma preferência
 * `rota:theme` que o Painel usa (SPEC 10.8) e aplica no `<html>` na hora, sem esperar o store do
 * Painel subir.
 */
import { useSyncExternalStore } from 'react';
import { getPref, onPrefChange, setPref, type ThemePref } from './storage';

let version = 0;
const listeners = new Set<() => void>();
const notify = () => {
  version++;
  for (const l of listeners) l();
};

function subscribe(l: () => void): () => void {
  listeners.add(l);
  const off = onPrefChange((k) => {
    if (k === 'theme') notify();
  });
  return () => {
    listeners.delete(l);
    off();
  };
}

export function setThemePref(theme: ThemePref): void {
  setPref('theme', theme);
  if (typeof document !== 'undefined') {
    const root = document.documentElement;
    if (theme === 'system') delete root.dataset.theme;
    else root.dataset.theme = theme;
  }
  notify();
}

export function useThemePref(): [ThemePref, (t: ThemePref) => void] {
  useSyncExternalStore(
    subscribe,
    () => version,
    () => version,
  );
  return [getPref('theme'), setThemePref];
}
